export const main_background_color = '';

export const backend_url = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BACKEND_URL_PROD
    : process.env.REACT_APP_BACKEND_URL_DEV;

export const api_endpoints = {
    // Users endpoints
    create_user: `${backend_url}/api/users/register`,
    
    // Events endpoints
    create_event: `${backend_url}/api/events`,
    submit_event_data: `${backend_url}/api/events/`,
    
    // Board endpoints
    get_board_by_board: (boardNum) => `${backend_url}/api/boards/board/${boardNum}`,
    get_todays_board: `${backend_url}/api/boards/today`,
}

